'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _class2, _temp2; /**
                                     * Created by zfc on 2016/11/29.
                                     */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactSlick = require('react-slick');

var _reactSlick2 = _interopRequireDefault(_reactSlick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LeftNavButton = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(LeftNavButton, _Component);

  function LeftNavButton() {
    (0, _classCallCheck3.default)(this, LeftNavButton);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(LeftNavButton).apply(this, arguments));
  }

  (0, _createClass3.default)(LeftNavButton, [{
    key: 'render',

    // first: PropTypes.bool
    value: function render() {
      var styles = require('./HelpDoc.scss');
      return _react2.default.createElement('a', (0, _extends3.default)({}, this.props, { className: styles.flexPrev }));
    }
  }]);
  return LeftNavButton;
}(_react.Component), _class.propTypes = {}, _temp);
var RightNavButton = (_temp2 = _class2 = function (_Component2) {
  (0, _inherits3.default)(RightNavButton, _Component2);

  function RightNavButton() {
    (0, _classCallCheck3.default)(this, RightNavButton);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(RightNavButton).apply(this, arguments));
  }

  (0, _createClass3.default)(RightNavButton, [{
    key: 'render',
    value: function render() {
      var styles = require('./HelpDoc.scss');
      return _react2.default.createElement('a', (0, _extends3.default)({}, this.props, { className: styles.flexNext }));
    }
  }]);
  return RightNavButton;
}(_react.Component), _class2.propTypes = {
  first: _react.PropTypes.bool
}, _temp2);

var HelpDoc = function (_Component3) {
  (0, _inherits3.default)(HelpDoc, _Component3);

  function HelpDoc() {
    (0, _classCallCheck3.default)(this, HelpDoc);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(HelpDoc).call(this));
  }

  (0, _createClass3.default)(HelpDoc, [{
    key: 'render',
    value: function render() {
      var styles = require('./HelpDoc.scss');
      // const isArrow = false;
      var settings = {
        dots: true,
        infinite: true,
        arrows: true,
        dotsClass: 'slick-dots ' + styles.dotsClass,
        fade: false, // fade 设置为 false
        speed: 1500,
        autoplay: false,
        // autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: true,
        prevArrow: _react2.default.createElement(LeftNavButton, this.props),
        nextArrow: _react2.default.createElement(RightNavButton, this.props)
      };
      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(
          'div',
          { className: styles.img },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/' },
            _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/logolight.png' })
          )
        ),
        _react2.default.createElement(
          _reactSlick2.default,
          (0, _extends3.default)({ className: styles.carousel }, settings),
          _react2.default.createElement(
            'div',
            { className: styles.carouselItem },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              '艺品网商户注册流程'
            ),
            _react2.default.createElement('img', { className: styles.img, src: 'http://tupian.goeasy.cn:9999/yipinwang/shzc.png' }),
            _react2.default.createElement(
              'div',
              { className: styles.zcdiv },
              _react2.default.createElement(
                'h3',
                { className: styles.tit },
                '注册流程：'
              ),
              _react2.default.createElement(
                'ol',
                { className: styles.right },
                _react2.default.createElement(
                  'li',
                  { className: styles.cont },
                  '1. 登录艺品网商户注册页面；'
                ),
                _react2.default.createElement(
                  'li',
                  { className: styles.cont },
                  '2. 选择注册商户类型,填写注册信息,上传营业执照照片；'
                ),
                _react2.default.createElement(
                  'li',
                  { className: styles.cont },
                  '3. 提交注册申请,等待艺品网审核；'
                ),
                _react2.default.createElement(
                  'li',
                  { className: styles.cont },
                  '4. 艺品网审核商户申请；'
                ),
                _react2.default.createElement(
                  'li',
                  { className: styles.cont },
                  '5. 审核通过,注册成功,收到注册成功短信。'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { width: '100%', height: 25 } },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/shoplogin', className: styles.linkbtn, style: { marginRight: 120 } },
                '返回'
              ),
              _react2.default.createElement(
                'a',
                {
                  href: 'http://tupian.goeasy.cn:9999/yipinwang/%e8%89%ba%e5%93%81%e7%bd%91%e8%89%ba%e5%93%81%e5%95%86%e6%b3%a8%e5%86%8c%e6%93%8d%e4%bd%9c%e8%af%b4%e6%98%8e.pdf',
                  className: styles.linkbtn,
                  download: '注册帮助手册' },
                '艺品商注册帮助手册'
              ),
              _react2.default.createElement(
                'a',
                {
                  href: 'http://tupian.goeasy.cn:9999/yipinwang/%e8%89%ba%e5%93%81%e7%bd%91%e6%9c%8d%e5%8a%a1%e5%95%86%e6%b3%a8%e5%86%8c%e6%93%8d%e4%bd%9c%e8%af%b4%e6%98%8e.pdf',
                  className: styles.linkbtn,
                  download: '注册帮助手册' },
                '服务商注册帮助手册'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.carouselItem },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              '艺品网艺品商户开店及创建数据流程'
            ),
            _react2.default.createElement('img', { className: styles.img, style: { width: 715, height: 180, marginTop: 30 },
              src: 'http://tupian.goeasy.cn:9999/yipinwang/shkd.png' }),
            _react2.default.createElement(
              'div',
              { className: styles.zcdiv, style: { marginTop: 25, width: 600, height: 140 } },
              _react2.default.createElement(
                'h3',
                { className: styles.tit },
                '开店流程：'
              ),
              _react2.default.createElement(
                'ol',
                { className: styles.right, style: { width: 270 } },
                _react2.default.createElement(
                  'li',
                  { className: styles.cont },
                  '1. 登录运营平台；'
                ),
                _react2.default.createElement(
                  'li',
                  { className: styles.cont },
                  '2. 选择商户系统；'
                ),
                _react2.default.createElement(
                  'li',
                  { className: styles.cont },
                  '3. 发起开店申请业务,填写店铺信息；'
                ),
                _react2.default.createElement(
                  'li',
                  { className: styles.cont },
                  '4. 艺品网审核开店申请；'
                ),
                _react2.default.createElement(
                  'li',
                  { className: styles.cont },
                  '5. 开店成功,收到短信提醒；'
                )
              ),
              _react2.default.createElement(
                'ol',
                { className: styles.right, style: { width: 215 } },
                _react2.default.createElement(
                  'li',
                  { className: styles.cont },
                  '6. 增加新的设计师/新的艺品产地等基础数据；'
                ),
                _react2.default.createElement(
                  'li',
                  { className: styles.cont },
                  '7. 创建艺品；'
                ),
                _react2.default.createElement(
                  'li',
                  { className: styles.cont },
                  '8. 发起艺品认证申请；'
                ),
                _react2.default.createElement(
                  'li',
                  { className: styles.cont },
                  '9. 艺品网审核艺品认证申请。'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { width: '100%', height: 25 } },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/shoplogin', className: styles.linkbtn, style: { marginRight: 120 } },
                '返回'
              ),
              _react2.default.createElement(
                'a',
                {
                  href: 'http://tupian.goeasy.cn:9999/yipinwang/%e5%95%86%e6%88%b7%e7%ae%a1%e7%90%86%e7%b3%bb%e7%bb%9f%e6%95%b0%e6%8d%ae%e5%88%9b%e5%bb%ba%e6%93%8d%e4%bd%9c%e8%af%b4%e6%98%8e.pdf',
                  className: styles.linkbtn,
                  download: '注册帮助手册' },
                '开店帮助手册'
              )
            )
          )
        )
      );
    }
  }]);
  return HelpDoc;
}(_react.Component);

exports.default = HelpDoc;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/HelpDoc/HelpDoc.js
 ** module id = 1487
 ** module chunks = 0
 **/